'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useRef,
  useState
} from 'react';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';

type PriceAndFitmentContextProviderProps = {
  children: ReactNode;
};
type Context = {
  priceAndAvailability: DealerPriceAvailabilityResponse;
  setPriceAndAvailability: Dispatch<
    SetStateAction<DealerPriceAvailabilityResponse>
  >;
  fitmentResponse: ProductFitmentResponse;
  setFitmentResponse: Dispatch<SetStateAction<ProductFitmentResponse>>;
  paramsRef: { current: string };
};

export const PriceAndFitmentContext = createContext<Context>(null);

export const PriceAndFitmentContextProvider = ({
  children
}: PriceAndFitmentContextProviderProps) => {
  const [priceAndAvailability, setPriceAndAvailability] = useState(null);
  const [fitmentResponse, setFitmentResponse] = useState(null);
  const paramsRef = useRef(null);

  const contextValues = useMemo(
    () => ({
      priceAndAvailability,
      setPriceAndAvailability,
      fitmentResponse,
      setFitmentResponse,
      paramsRef
    }),
    [priceAndAvailability, fitmentResponse]
  );

  return (
    <PriceAndFitmentContext.Provider value={contextValues}>
      {children}
    </PriceAndFitmentContext.Provider>
  );
};

export const usePriceAndFitmentContext = () => useContext(PriceAndFitmentContext);